import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useLocation, useParams, Link } from 'react-router-dom';
import { baseUrl } from "../../../comman/config";
import UserMasterForm from "../../../components/Form/Master/UserMasterForm";

// View User: the Add/Edit form with nothing on it that writes.
//
// It exists as a route of its own rather than as a flag on Edit because of what the router asks
// for. /user_master/edit/:id needs Update -- that is what an "edit" path means to
// comman/permissions.js -- so a department POC holding only View on User Master is turned away
// from it before the page renders. This path asks for View, which is what they have.
//
// The subject comes from the list, the same as Edit, and is fetched by id when it does not: a
// reload carries no router state, and "the row you were looking at" should survive one.
export default function ViewUserMaster() {

    const location = useLocation();
    const params = useParams();
    const [fetched, setFetched] = useState(null);
    const [loadError, setLoadError] = useState('');
    const detail = location.state ?? fetched;

    useEffect(() => {
        if (location.state) return;
        const load = async () => {
            try {
                const id = Number(atob(params.id));
                // There is no read-one endpoint; the list is already narrowed to the departments
                // this user may see, so picking out of it cannot show them an account the list
                // itself would not have.
                const response = await axios.get(`${baseUrl}/user_master/list`);
                const row = (response.data?.data ?? []).find((user) => Number(user.id) === id);
                if (!row) {
                    setLoadError('That user is not in your departments, or no longer exists.');
                    return;
                }
                setFetched([row]);
            } catch (error) {
                console.log(error);
                setLoadError(error?.response?.data?.msg ?? 'Could not load the user.');
            }
        };
        load();
    }, [location.state, params.id]);

    return (
        <div className="p-4">
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">View User</h1>
                <div>
                    <Link to="/user_master/list">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Back</button>
                    </Link>
                </div>
            </div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg px-4 py-2">
                {loadError
                    ? <div className="text-red-500 py-4">{loadError}</div>
                    : <UserMasterForm detail={detail} page="user_master" readOnly />}
            </div>
        </div>
    )
}
